module.exports = __webpack_public_path__ + "img/yyzx.cd123058.png";